module.exports = __webpack_public_path__ + "img/99.00380f20.svg";